import useOrganizationName from '@/hooks/useOrganizationName';
import api from '@/services/api';
import { skipToken, useQuery } from '@tanstack/react-query';

const useGetServiceById = (serviceId: string | undefined) => {
  const organizationName = useOrganizationName();
  return useQuery({
    queryKey: ['services', serviceId, organizationName],
    queryFn: serviceId
      ? () => api.services.getServiceById(serviceId)
      : skipToken
  });
};

export default useGetServiceById;
